import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

const defaultEl = {
  id: null,
  name: '',
  system_name: '',
  action: '',
  flag_before_holidays: false
};

export default {
  name: 'EventEdit',
  data () {
    return {
      editEl: defaultEl,
      isLoading: false
    }
  },
  validations: {
    editEl: {
      name: { required },
      system_name: { required },
      action: { required },
      flag_before_holidays: { required }
    }
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-events'
    },
    basePath: {
      type: String,
      default: ''
    },
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    actionOptions () {
      const actions = [
        { value: 'minus', text: this.$t('event.action-options.minus') },
        { value: 'plus', text: this.$t('event.action-options.plus') },
        { value: 'neutral', text: this.$t('event.action-options.neutral') }
      ];
      return actions;
    },
    baseTransParam () {
      return 'event';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.actions.edit`);
      }
      return this.$t(`${this.baseTransParam}.actions.new`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        this.ApiRequest.request(this.basePath + '/save' + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
